import React, { Fragment, useEffect, useState } from 'react'
import TTBFaq from 'components/ttb-home/ttb-faq'
import TTBProduct from 'components/ttb-home/ttb-product'
import { GoogleMapSearchFilter } from 'components/google-map-search-filter'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import { withI18next } from 'lib/i18n/withI18next'
import PropTypes from 'prop-types'
import AddressApi from 'lib/api/address'

const TTBHBrowserOnlySection = ({ t, internationalization }) => {
  const [showCoachMark, setShowCoachMark] = useState(true)
  const [locations, setLocations] = useState(null)

  useEffect(() => {
    const fetchLocations = async () => {
      const options = {
        pickup_type: GoogleMapSearchFilter.PICKUP_TYPES,
        shop_id: internationalization.shop,
      }

      const res = await AddressApi.getPickUpPoints(options)
      if (res) {
        setLocations(res?.pickup)
      }
    }

    fetchLocations()
  }, [internationalization])

  return (
    <Fragment>
      <TTBProduct />
      <TTBFaq />
      {locations?.length > 0 && internationalization.shop === 1 && (
        <GoogleMapSearchFilter
          hideTempDisabled
          t={t}
          locations={locations}
          id="google-map-filter-area"
          showCoachMark={showCoachMark}
          setCoachMark={setShowCoachMark}
        />
      )}
    </Fragment>
  )
}

TTBHBrowserOnlySection.propTypes = {
  t: PropTypes.func.isRequired,
  internationalization: PropTypes.shape({
    shop: PropTypes.number.isRequired,
  }).isRequired,
}

export default compose(
  connect((state) => ({
    internationalization: state.internationalization,
  })),
  withI18next(),
)(TTBHBrowserOnlySection)
